var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.0124C0 15.7424 0.210688 15.5234 0.470586 15.5234H15.5293C15.7892 15.5234 15.9999 15.7424 15.9999 16.0124C15.9999 16.2825 15.7892 16.5014 15.5293 16.5014H0.470586C0.210688 16.5014 0 16.2825 0 16.0124Z",
    fill: "#3E4E5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33445 1.5755C8.13166 1.44548 7.86834 1.44548 7.66555 1.5755L7.65176 1.58401L2.24405 4.79208H13.7559L8.34824 1.58401L8.33445 1.5755ZM8.82121 0.738448C8.31907 0.420519 7.68094 0.420517 7.17879 0.738444L0.237313 4.85641C0.0519768 4.96636 -0.0389519 5.19214 0.015784 5.40649C0.0705199 5.62083 0.257215 5.77007 0.470629 5.77007H15.5294C15.7428 5.77007 15.9295 5.62083 15.9842 5.40649C16.039 5.19214 15.948 4.96636 15.7627 4.85641L8.82121 0.738448Z",
    fill: "#3E4E5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3026 6.9375C12.5625 6.9375 12.7732 7.15643 12.7732 7.42649V13.3755H13.9833V7.42649C13.9833 7.15643 14.194 6.9375 14.4539 6.9375C14.7138 6.9375 14.9245 7.15643 14.9245 7.42649V13.8645C14.9245 14.1345 14.7138 14.3534 14.4539 14.3534H12.3026C12.0427 14.3534 11.832 14.1345 11.832 13.8645V7.42649C11.832 7.15643 12.0427 6.9375 12.3026 6.9375Z",
    fill: "#3E4E5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92469 6.9375C7.18458 6.9375 7.39527 7.15643 7.39527 7.42649V13.3755H8.60535V7.42649C8.60535 7.15643 8.81604 6.9375 9.07594 6.9375C9.33583 6.9375 9.54652 7.15643 9.54652 7.42649V13.8645C9.54652 14.1345 9.33583 14.3534 9.07594 14.3534H6.92469C6.66479 14.3534 6.4541 14.1345 6.4541 13.8645V7.42649C6.4541 7.15643 6.66479 6.9375 6.92469 6.9375Z",
    fill: "#3E4E5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54578 6.9375C1.80568 6.9375 2.01637 7.15643 2.01637 7.42649V13.3755H3.22644V7.42649C3.22644 7.15643 3.43713 6.9375 3.69703 6.9375C3.95693 6.9375 4.16762 7.15643 4.16762 7.42649V13.8645C4.16762 14.1345 3.95693 14.3534 3.69703 14.3534H1.54578C1.28588 14.3534 1.0752 14.1345 1.0752 13.8645V7.42649C1.0752 7.15643 1.28588 6.9375 1.54578 6.9375Z",
    fill: "#3E4E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bankTransfer.5f45d8cf.svg";
export { ForwardRef as ReactComponent };